module.exports = __webpack_public_path__ + "assets/87a35eff963fb37b8b5c1eafd9208c71.png";